export default __webpack_public_path__ + "static/media/blog16.8b326420.jpeg";